import styled, {css} from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {Card} from '~/components/general/card/Card'
import {Button} from '~/components/general/button/Button'

export {
  PageWrapper,
  HeaderCard,
  HeaderCenter,
  Logo,
  Footer,
  PoweredBySection,
  PoweredByLogo,
  Grid,
  Column,
  SelectedGlobal,
  BookButton,
} from './BookingsPortalPage.styled'

export const ListCard = styled(Card)`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
`

export const Row = styled(Container).attrs({
  justify: 'space-between',
  align: 'center',
  spacing: 2,
})`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.grey.grey40};
  &:last-child {
    border-bottom: none;
  }
`

export const RowLeft = styled(Container).attrs({
  align: 'center',
  spacing: 2,
})<{$cancelled?: boolean}>`
  ${({$cancelled}) =>
    $cancelled &&
    css`
      & * {
        text-decoration: line-through;
        opacity: 0.7;
      }
    `}
`

export const HistoryButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  flex: 1;
  min-width: 110px;
  @media (max-width: 420px) {
    font-size: 12px;
    padding: 8px 10px;
    min-width: 88px;
  }
`

export const ActionButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  flex: 1;
  min-width: 110px;
  background-color: ${({theme}) => theme.colors.secondary.orange200};
  &:hover {
    background-color: ${({theme}) => theme.colors.secondary.orange600};
  }
  @media (max-width: 420px) {
    font-size: 12px;
    padding: 8px 10px;
    min-width: 88px;
  }
`

export const ActionsContainer = styled(Container).attrs({
  align: 'center',
  spacing: 2,
  flex: true,
})`
  flex-wrap: wrap;
  gap: 8px;
`

export const EmptyState = styled(Container)`
  padding: 12px 0;
`

export const HistoryList = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})`
  padding-left: 12px;
  border-left: 2px solid ${({theme}) => theme.colors.grey.grey20};
`

export const HistoryItem = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})`
  padding: 8px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.grey.grey40};
  &:last-child {
    border-bottom: none;
  }
`

// Reschedule form section (full width under the grid)
export const RescheduleFormCard = styled(Card)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin: 0 auto;
`

export const ButtonsRow = styled(Container).attrs({
  spacing: 2,
  align: 'center',
})`
  display: flex;
`

export const OrangeButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  background-color: ${({theme}) => theme.colors.secondary.orange200};
  color: ${({theme}) => theme.colors.black};
  flex: 1;
  min-width: 140px;
  justify-content: center;

  &:hover {
    background-color: ${({theme}) => theme.colors.secondary.orange600};
  }

  &:disabled {
    background-color: ${({theme}) => theme.colors.secondary.orange200};
    opacity: 0.5;
    cursor: not-allowed;
  }
`
